<script>
import _ from 'lodash'
import { cartComputed, cartMethods } from '@state/helpers'
import RoomExtrabed from '@components/room-extrabed'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { RoomExtrabed },
  props: {
    room: { type: Object, required: true },
    ratePlan: { type: Object, required: true },
  },
  data: () => ({
    showExtrabed: false,
  }),
  computed: {
    ...cartComputed,
    ...mapGetters('cart/rooms', ['getItem']),
    ...mapGetters('rooms', ['getAvailability']),
    item() {
      return this.getItem(this.room, this.ratePlan)
    },
    availability() {
      return this.getAvailability(this.room.id)
    },
    roomDropdown() {
      let end = 1

      if (this.item) {
        end += this.availability + this.selectModel
      } else {
        end += this.availability
      }

      return _.range(0, end)
    },
    extraBeds() {
      return _.range(0, this.room.extraBeds + 1)
    },
    selectModel: {
      get() {
        return this.item ? this.item.qty : 0
      },
      set(val) {
        this.roomCart({
          room: this.room,
          ratePlan: this.ratePlan,
          qty: val,
          extrabed: Array(val).fill(0),
        })
      },
    },
    extrabedModel: {
      get() {
        return this.item ? this.item.extrabed : []
      },
      set(val) {
        this.roomCart({
          room: this.room,
          ratePlan: this.ratePlan,
          qty: this.selectModel,
          extrabed: val,
        })
        // this.updateRoomCart({
        //   room: this.room,
        //   ratePlan: this.ratePlan,
        //   qty: this.selectModel,
        //   extrabed: val,
        // })
      },
    },
    extrabedCart() {
      return this.selectModel ? this.item.extrabed : []
    },
  },
  methods: {
    ...mapActions(['roomCart']),
    ...cartMethods,
    addExtrabed() {
      this.showExtrabed = true
      // this.extrabedModel = 1
    },
    updateExtrabedCart(index, event) {
      // const { value } = event.target
      // console.log('item', this.item)
      // console.log('index', index)
      // console.log('value', value)
      // this.updateExtrabedCart({
      //     room: this.room,
      //     ratePlan: this.ratePlan,
      //     extrabed: val,
      //     qty: this.selectModel,
      //   })
    },
    // initEb(val) {
    //   let arr = Array(val).fill(0)

    //   if (!this.item) {
    //     return arr
    //   }

    //   return arr.map((val, idx) => this.item.extrabed[idx] || val)
    // },
  },
}
</script>

<template>
  <div>
    <div class="px-3 my-3">
      <div class="relative">
        <select v-model="selectModel" class="input">
          <option v-for="x in roomDropdown" :key="x" :value="x">
            <template v-if="x === 0 && !selectModel">
              Select room
            </template>
            <template v-else>{{ x }}</template>
          </option>
        </select>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
        >
          <BaseIcon name="chevron-down" />
        </div>
      </div>
      <p v-if="availability <= 10" class="text-sm text-center mt-2">
        <strong v-if="availability < 2" class="text-red-600">
          {{ availability === 1 ? 'Our last room!' : 'Sold out!' }}
        </strong>
        <strong v-else class="text-green-600">
          Limited availablity
        </strong>
      </p>

      <RoomExtrabed
        v-model="extrabedModel"
        :cart="item"
        :rate-plan="ratePlan"
      />

      <!-- <div v-if="ratePlan.extrabedAllowed && selectModel > 0" class="mt-3">
        <template v-if="showExtrabed">
          <div v-for="(ebQty, ebIndex) in extrabedCart" :key="ebIndex">
            <div class="text-sm font-medium">
              Extra bed room {{ ebIndex + 1 }}
            </div>
            <div class="relative mb-3">
              <select
                :value="extrabedCart[ebIndex]"
                class="input"
                @change="updateExtrabedCart(ebIndex, $event)"
              >
                <option v-for="x in extraBeds" :key="x" :value="x">
                  <template v-if="x">
                    {{ `${x}x ${room.extraBedRate.currency}` }}
                    {{ (x * room.extraBedRate.display) | currency }}
                  </template>
                  <template v-else>
                    {{ x }}
                  </template>
                </option>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
              >
                <BaseIcon name="chevron-down" />
              </div>
            </div>
          </div>
        </template>
        <a
          v-else
          class="text-sm font-medium text-blue-600 cursor-pointer hover:underline"
          @click="addExtrabed"
        >
          Need extrabed?
        </a>
      </div> -->
    </div>
  </div>
  <!-- rooms column -->
</template>
